var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.QMyClientsSubmenu),(_setup.user)?_c(_setup.QConservedPoliciesDrilldown,{staticClass:"mx-4",attrs:{"agentCode":_setup.user.AgentCode}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }